export default __webpack_public_path__ + "c9806c1874de5e2eb208c676a77cee80.svg";